<script>
export default {
  name: 'personelTalepOnayList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    rejectRecord(id) {
      this.$emit('rejectRecord', id);
    },
    approveRecord(id) {
      this.$emit('approveRecord', id);
    },
    openDetailDialog(item) {
      this.$emit('details', item);
    },
  },
};
</script>

<template>
  <tr>
    <td>{{ item.santiye }}</td>
    <td> {{ item.pozisyon }} </td>
    <td> {{ item.kisisayisi }}</td>
    <td>
      <v-btn @click="rejectRecord(item.pkart)" color="darken-3" small icon fat text>
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </td>
    <td>
      <v-btn @click="approveRecord(item.pkart)" color="darken-3" small icon fat text>
        <v-icon color="success">
        mdi-check
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
